export default "__VITE_ASSET__CRwhqEeZ__"